<template>
  <vs-popup :title="$t('BaseSalePriceHistory')" :active.sync="showModal">
    <vs-tabs vs-alignment="fixed" alignment="fixed" v-if="showModal">
      <vs-tab :label="$t('Table')" class="mt-6 minimum-height">
        <div v-cloak>
          <div class="vx-row pt-4">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                @result="saveResult"
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('ItemCode') },
                  { title: $t('Price') },
                  { title: $t('User') },
                  { title: $t('CreateOn') },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 15%">
                    {{ row.itemCode }}
                  </td>
                  <td style="width: 15%">
                    {{ row.price.toLocaleString() }}
                  </td>
                  <td style="width: 20%">
                    {{ row.userName }}
                  </td>
                  <td style="width: 40%">
                    {{ row.persianCreateOn.split(" ")[0] }}<br />{{
                      row.persianCreateOn.split(" ")[1]
                    }}
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div></vs-tab
      >
      <vs-tab :label="$t('Chart')" class="mt-6 minimum-height">
        <chartjs-component-line-chart
          :height="200"
          :data="dataForChart"
          :options="optionsForChart"
        ></chartjs-component-line-chart>
      </vs-tab>
    </vs-tabs>
  </vs-popup>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";

import ChartjsComponentLineChart from "@/views/charts-and-maps/charts/chartjs/charts-components/ChartjsComponentLineChart.vue";
export default {
  name: "saleManagement_Contract_Management_BaseSalePrice",
  components: {
    DataGrid,
    ChartjsComponentLineChart,
  },
  data() {
    var id = this.$route.params.id;
    return {
      gridDataSource: {
        type: "app",
        service: `/Sales/api/BaseSalePriceQuery/${id}/histories-of-base-sale-price`,
      },
      gridSearchData: {},
      dataForChart: {
        labels: [],
        datasets: [
          {
            fill: false,
            lineTension: 0,
            backgroundColor: "rgba(0,0,255,1.0)",
            borderColor: "rgba(0,0,255,0.3)",
            data: [],
          },
        ],
      },
      optionsForChart: {
        legend: { display: false },
        plugins: {
          customCanvasBackgroundColor: {
            color: "lightGreen",
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (value, index, values) {
                  return value.toLocaleString();
                },
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            // Optionally, format the tooltip labels the same way
            label: function (tooltipItem, chart) {
              var datasetLabel =
                chart.datasets[tooltipItem.datasetIndex].label || "";
              return datasetLabel + ": " + tooltipItem.yLabel.toLocaleString();
            },
          },
        },
      },
      baseSalePriceData: [],
    };
  },
  props: {
    show: { default: false },
    itemCode: {
      type: String,
    },
    keywords: {},
  },
  computed: {
    showModal: {
      get: function () {
        if (this.show) {
          this.setItemCode();
        }
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  mounted() {},
  methods: {
    setItemCode() {
      this.gridSearchData.itemCode = this.itemCode;
    },
    saveResult(data) {
      this.baseSalePriceData = data;
      this.dataForChart.datasets[0].data = [];
      this.dataForChart.labels = [];
      for (let item of data) {
        this.dataForChart.labels.unshift(item.persianCreateOn);
        this.dataForChart.datasets[0].data.unshift(item.price);
      }
    },
  },
};
</script>

<style scoped>
::v-deep canvas#line-chart {
  padding: 10px;
  padding-top: 20px;
  border-radius: 6px;
}

.minimum-height {
  min-height: 400px;
}
</style>
